﻿'use strict';

angular.module('ntmApp').factory('ActivityHighlighting', ['TALocationService',
    function (TALocationService) {

        function ActivityHighlighting(todaysAssignments) {

            var self = this;

            self.HighlightActivity = function (activity) {

                switch (activity.typeId) {
                    case todaysAssignments.activityType.Room: case todaysAssignments.activityType.Rack: case todaysAssignments.activityType.Cage: case todaysAssignments.activityType.Preparation:

                        if (todaysAssignments.isRoomGroupsLevel() && isActivityMatchedInRoom(activity)) {
                            todaysAssignments.showReminders = false;

                            self.roomActivitiesGroups.forEach(function (roomActivitiesGroup) {
                                self.HighlightActivityInRoomGroup(activity.scheduleId, roomActivitiesGroup);
                            });
                        }
                        else {
                            sessionStorage.scheduleIdToHighlight = activity.scheduleId;
                            TALocationService.GoToTheRoomGroups(activity.facilityCode, activity.roomNumber);
                        }

                        break;

                    case todaysAssignments.activityType.QCCheck:
                        if (todaysAssignments.isRoomGroupsLevel() && isActivityMatchedInRoom(activity)) {
                            todaysAssignments.showReminders = false;

                            self.roomActivitiesGroups.forEach(function (roomActivitiesGroup) {
                                self.HighlightActivityInRoomGroup(activity.scheduleId, roomActivitiesGroup);
                            });
                        }
                        else {
                            sessionStorage.scheduleIdToHighlight = activity.scheduleId;
                            TALocationService.GoToTheRoomGroups(activity.facilityCode, activity.roomNumber);
                        }

                        break;

                    case todaysAssignments.activityType.Staff: case todaysAssignments.activityType.FacilityArea:

                        if (todaysAssignments.isHomePageLevel()) {
                            todaysAssignments.showReminders = false;
                            self.TryToHighlightOtherActivity(activity.scheduleId);
                        }
                        else {
                            sessionStorage.scheduleIdToHighlight = activity.scheduleId;
                            TALocationService.GoToTheHomePage();
                        }

                        break;

                    case todaysAssignments.activityType.Equipment:

                        if (activity.roomNumber) {

                            if (todaysAssignments.isRoomGroupsLevel() && isActivityMatchedInRoom(activity)) {
                                todaysAssignments.showReminders = false;

                                self.roomActivitiesGroups.forEach(function (roomActivitiesGroup) {
                                    self.HighlightActivityInRoomGroup(activity.scheduleId, roomActivitiesGroup);
                                });
                            }
                            else {
                                sessionStorage.scheduleIdToHighlight = activity.scheduleId;
                                TALocationService.GoToTheRoomGroups(activity.facilityCode, activity.roomNumber);
                            }
                        } else {

                            if (todaysAssignments.isHomePageLevel()) {
                                todaysAssignments.showReminders = false;
                                self.TryToHighlightOtherActivity(activity.scheduleId);
                            }
                            else {
                                sessionStorage.scheduleIdToHighlight = activity.scheduleId;
                                TALocationService.GoToTheHomePage();
                            }
                        }

                        break;
                }
            };

            self.HighlightActivityInRoomGroup = function (scheduleId, roomActivitiesGroup) {
                var found = false;

                if (todaysAssignments.isRoomGroupsLevel()) {

                    roomActivitiesGroup.activities.forEach(function (record) {
                        record.highlighted = false;
                    });

                    var roomGroupActivity = roomActivitiesGroup.activities.firstOrDefault(function (record) {
                        return parseInt(record.scheduleId) === parseInt(scheduleId);
                    });

                    if (roomGroupActivity) {
                        roomGroupActivity.isHighlighted = true;
                        todaysAssignments.scrollToActivity(scheduleId);
                        found = true;
                    } else {
                        //Try to find matches in Ad Hoc Counts
                        var adHocCountActivity = roomActivitiesGroup.adHocCountActivities.firstOrDefault(function (record) {
                            return parseInt(record.scheduleId) === parseInt(scheduleId);
                        });

                        if (adHocCountActivity) {
                            adHocCountActivity.isHighlighted = true;
                            todaysAssignments.scrollToActivity(scheduleId);
                            found = true;
                        }
                    }
                }

                return found;
            };

            self.TryToHighlightOtherActivity = function (scheduleId) {
                var found = false;

                if (todaysAssignments.otherActivities && todaysAssignments.otherActivities.length > 0) {

                    todaysAssignments.otherActivities.forEach(function (record) {
                        record.isHighlighted = false;
                    });

                    var otherActivity = todaysAssignments.otherActivities.firstOrDefault(function (other) {
                        return parseInt(other.scheduleId) === parseInt(scheduleId);
                    });

                    if (otherActivity) {
                        otherActivity.isHighlighted = true;
                        found = true;
                        todaysAssignments.scrollToActivity(scheduleId);
                    }
                }

                return found;
            };

            function isActivityMatchedInRoom(activity) {
                return todaysAssignments.roomInfo && todaysAssignments.roomInfo.facilityCode === activity.facilityCode && todaysAssignments.roomInfo.roomNumber === activity.roomNumber;
            }

            function initialize() {

            }

            initialize();
        }

        return (ActivityHighlighting);
    }]);